<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon">
    <mat-icon class="mdi-24px" fontIcon="mdi-account-group" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <mat-form-field style="width: 300px; margin-left: 10px;">
    <input matInput [(ngModel)]="filterString" (keyup)="applyFilter($any($event.target).value)" placeholder="Search" />
    @if (filterString) {
    <button mat-icon-button matSuffix (click)="applyFilter('')" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
  <div class="button-end">
    <mat-paginator #paginator [pageIndex]="0" [pageSize]="20"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]"></mat-paginator>
  </div>
</div>

<div class="table-container">
  <table mat-table #unitTable [dataSource]="unitDataSource" matSort (matSortChange)="sortChanged($event)" multiTemplateDataRows>
    <!-- action column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="column-action">
        @if (canManage) {
        <button mat-icon-button (click)="addOrEditUnit(null); $event.stopPropagation();" style="outline: none;" title="Add Unit">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
        <button mat-icon-button title="Upload Units from JSON" style="outline: none;"
          (click)="jsonInput.click(); $event.stopPropagation();">
          <mat-icon class="mdi-24px" fontIcon="mdi-upload"></mat-icon>
        </button>
        <button mat-icon-button title="Download Units as JSON" style="outline: none;"
          (click)="openDownloadDialog(); $event.stopPropagation();">
          <mat-icon class="mdi-24px" fontIcon="mdi-download"></mat-icon>
        </button>
        }
      </th>
      <td mat-cell *matCellDef="let element" class="column-action">
        @if (canManage) {
        <button mat-icon-button (click)="addOrEditUnit(element); $event.stopPropagation()" style="outline: none;"
          title="Edit {{ element.name }}">
          <mat-icon class="mdi-18px self-center" fontIcon="mdi-square-edit-outline"></mat-icon>
        </button>
        <button mat-icon-button (click)="deleteUnit(element); $event.stopPropagation()" style="outline: none;"
          title="Delete {{ element.name }}">
          <mat-icon class="mdi-18px self-center" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
        }
      </td>
    </ng-container>
    <!-- shortName Column -->
    <ng-container matColumnDef="shortName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-short-name">Short Name</th>
      <td mat-cell *matCellDef="let element" class="column-short-name">{{ element.shortName }}</td>
    </ng-container>
    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-name">Name</th>
      <td mat-cell *matCellDef="let element" class="column-name">{{ element.name }}</td>
    </ng-container>
    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div [@detailExpand]="element.id == expandedElementId ? 'expanded' : 'collapsed'" style="overflow: hidden">
          @if (expandedElementId === element.id) {
          <div class="expanded-detail-div">
            <app-admin-unit-users [unitId]="element.id" [canManage]="canManage"></app-admin-unit-users>
          </div>
          }
        </div>
      </td>
    </ng-container>
    <!-- row definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class]="getRowClass(row.id)" (click)="rowClicked(row)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
</div>

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}

<input hidden type="file" #jsonInput accept=".json" (change)="selectFile($event)" />
